module.exports = "<p-breadcrumb *ngIf=\"navigationService.items?.length > 0\" [model]=\"navigationService.items\"></p-breadcrumb>\r\n"